import React, { Component } from 'react';
import './colorPicker.less';
import reactCSS from 'reactcss';
import { SketchPicker } from 'react-color';

class SketchExample extends React.Component {

    state = {
        displayColorPicker: this.props.displayColorPicker,
        color:this.props.defaultColor,
    };

    handleClick = () => {
        this.props.CardFontColorClick();
    };
    componentWillReceiveProps=(nextProps)=>{
        if(nextProps.defaultColor){
            let result=this.hexToRgb(nextProps.defaultColor)
            this.setState({
                color:result
            })
        }
    }
    handleClose = () => {
        this.props.CardFontColorClose();
    };
    hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);    
        return result ? {        
            r: parseInt(result[1], 16),       
            g: parseInt(result[2], 16),        
            b: parseInt(result[3], 16),
            a:1, 
        } : null;
    };
    handleChange = (color) => {
        this.setState({ color: color.rgb })
        this.props.activityCardFontColorChange(color);
    };

    render() {
        const styles = reactCSS({
            'default': {
                color: {
                    width: '36px',
                    height: '14px',
                    borderRadius: '2px',
                    background: `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`,
                },
                swatch: {
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'inline-block',
                    cursor: 'pointer',
                },
                popover: {
                    position: 'absolute',
                    zIndex: '2',
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });

        return (
            <div>
                <div style={styles.swatch} onClick={this.handleClick}>
                    <div style={styles.color} />
                </div>
                {this.props.displayColorPicker ? <div style={styles.popover}>
                    <div style={styles.cover} onClick={this.handleClose} />
                    <SketchPicker color={this.state.color} onChange={this.handleChange} />
                </div> : null}

            </div>
        )
    }
}
export default SketchExample